// Nome curto da loja na URL (`/loja/{slug}`), no lugar dos uuids de empresa e
// estabelecimento. O DONO do slug e o backend: ele garante que e unico e o guarda
// separado do nome, entao renomear a loja nao quebra link que ja circula.
export type LojaSlug = {
  slug: string;
  empresaId: string;
  estabelecimentoId: string;
};

// Minusculo, sem acento, palavras separadas por um hifen so. Aplicado ao que vem da URL
// para que `/loja/Durango-Dionisio-Torres` caia na mesma loja.
export function slugNormaliza(texto: string): string {
  return (texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// O que `GET aps://venda/loja/{slug}` devolve (constel-aps, `esquema/venda/loja`).
// Slug inexistente ou suspenso responde 404.
export type LojaServidor = {
  id?: string;
  slug: string;
  situacao?: number;
  empresa: { id: string; codigo?: string; nome?: string };
  estabelecimento: { id: string; codigo?: string; nome?: string };
};

export function lojaSlugDeServidor(loja: LojaServidor): LojaSlug | null {
  if (!loja?.slug || !loja.empresa?.id || !loja.estabelecimento?.id) {
    return null;
  }
  return { slug: loja.slug, empresaId: loja.empresa.id, estabelecimentoId: loja.estabelecimento.id };
}

// RESERVA. O servidor manda; isto so responde quando a chamada falha (backend novo ainda
// nao publicado, queda de rede). Pode sair quando `venda/loja` estiver no ar com a loja de
// teste cadastrada.
//
// Palavras que ja sao rota do modulo (`shop`, `confirma`, `checkout`, `details`,
// `pedidos`, `perfil`, `config-*`, `aceite`, `cardapio`) nao podem virar slug: a rota
// literal casa antes.
const CATALOGO: LojaSlug[] = [
  {
    slug: 'durango-dionisio-torres',
    empresaId: '0d1542e1-71fd-40f9-b1f7-ae00ab08626c',
    estabelecimentoId: 'fe5b422e-bfb2-4328-83d4-7876020acef9',
  },
];

export function lojaSlugCatalogoEncontra(slug: string): LojaSlug | null {
  const chave = slugNormaliza(slug);
  if (!chave) {
    return null;
  }
  const loja = CATALOGO.find(l => l.slug === chave);
  return loja ? { ...loja } : null;
}
